import type {Result, UseCase} from 'framework';
import type {SavedMealError} from '../../domain/errors';
import type {SavedMeal} from '../../domain/saved-meal';
import type {SavedMealId} from '../../domain/saved-meal-id.value-object';
import type {SavedMealRepository} from '../ports/saved-meal.repository';

export class GetSavedMeal implements UseCase<[SavedMealId], SavedMeal> {
  constructor(private readonly repository: SavedMealRepository) {}

  execute(id: SavedMealId): Promise<Result<SavedMeal, SavedMealError>> {
    return this.repository.getById(id);
  }
}
